import React from 'react';
import './LoadingPage.css';

const LoadingPage: React.FC = () => {
  return (
    <div className="loading-page">
      {/* Animated Background Elements */}
      <div className="loading-bg">
        <div className="loading-particle particle-1"></div>
        <div className="loading-particle particle-2"></div>
        <div className="loading-particle particle-3"></div>
        <div className="loading-particle particle-4"></div>
        <div className="loading-particle particle-5"></div>
        <div className="loading-particle particle-6"></div>
        <div className="loading-particle particle-7"></div>
        <div className="loading-particle particle-8"></div>
      </div>

      {/* Tech Grid Pattern */}
      <div className="loading-grid"></div>

      {/* Loading Container */}
      <div className="loading-container">
        {/* Logo / Brand */}
        {/* <div className="loading-logo">
          <span className="logo-text">ZiTech Solutions</span>
          <span className="logo-dot">.</span>
        </div> */}

        {/* Animated Loader */}
        <div className="loader-wrapper">
          <div className="tech-loader">
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
          </div>
        </div>

        {/* Loading Text */}
        <div className="loading-text">
          <span className="loading-word">Loading</span>
          <span className="loading-dots">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
          </span>
        </div>

        {/* Subtitle */}
        <p className="loading-subtitle">Please wait while we prepare your experience</p>
      </div>

      {/* Bottom Tech Bar */}
      <div className="loading-tech-bar">
        <div className="tech-bar-line"></div>
        <div className="tech-bar-line"></div>
        <div className="tech-bar-line"></div>
      </div>
    </div>
  );
};

export default LoadingPage;